import * as yup from 'yup';

export const LoginSchema = yup.object({
    email: yup.string().email('email_invalid').required('required'),
    password: yup.string().required('required'),
});
